export default __webpack_public_path__ + "static/media/help4.26e33fd0.png";